

(function(){
  var VARIANTS={
    adult:{vid:'37566832771242',dup:'46450031624362',price:98,label:'Adult Necklace'},
    kids:{vid:'42972273737898',dup:'46449528275114',price:94,label:'Kids Necklace'},
    pet:{vid:'44979316719786',dup:'46449552654506',price:94,label:'Pet Pendant'}
  };
  var state={variant:'adult',qty:1};
  var priceRow=document.querySelector('.price-row strong');
  var installments=document.querySelector('.installments b');
  var stickyInfo=document.querySelector('.sticky-info');
  var variantBtns=[].slice.call(document.querySelectorAll('.variant-grid .variant-card'));
  var qtyBtns=[].slice.call(document.querySelectorAll('.quantity-grid button'));
  var keys=['adult','kids','pet'];
  function fmt(n){return '$'+n.toFixed(2);}
  function total(){
    var v=VARIANTS[state.variant];
    if(state.qty>1){var d=state.qty===2?0.9:0.8;return v.price*state.qty*d;}
    return v.price;
  }
  function render(){
    var v=VARIANTS[state.variant];
    variantBtns.forEach(function(b,i){var on=keys[i]===state.variant;b.classList.toggle('selected',on);b.setAttribute('aria-pressed',on);});
    qtyBtns.forEach(function(b,i){
      var q=[1,2,4][i], on=q===state.qty;
      b.classList.toggle('selected',on); b.setAttribute('aria-pressed',on);
      var allowed=true;
      b.disabled=!allowed; b.style.opacity=allowed?'':'0.45';
    });
    var t=total();
    if(priceRow)priceRow.textContent=fmt(t);
    if(installments)installments.textContent=fmt(t/4);
    if(stickyInfo)stickyInfo.innerHTML='<b>'+v.label+'</b><span>'+fmt(t)+' · View options</span>';
    var bcta=document.getElementById('bcta');
    renderBundle();
  }
  variantBtns.forEach(function(b,i){b.addEventListener('click',function(){state.variant=keys[i];render();});});
  qtyBtns.forEach(function(b,i){b.addEventListener('click',function(){if(b.disabled)return;state.qty=[1,2,4][i];render();});});

  function cartParts(){
    var v=VARIANTS[state.variant];
    if(state.qty>1)return [v.dup+':'+state.qty];
    return [v.vid+':1'];
  }
  function toast(msg){var t=document.querySelector('.toast');if(!t)return;t.textContent=msg;t.classList.add('show');setTimeout(function(){t.classList.remove('show');},2200);}
  function openCart(parts){var items=parts.map(function(s){var a=s.split(':');return {id:+a[0],quantity:+a[1]};});fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})}).then(function(){setTimeout(function(){window.location='/cart';},500);});toast('Adding to cart…');}
  var atc=document.querySelector('.primary-btn'); if(atc)atc.addEventListener('click',function(){openCart(cartParts());});
  var shop=document.querySelector('.shop-btn'); if(shop)shop.addEventListener('click',function(){window.location='/cart/'+cartParts().join(',');});var morePay=document.querySelector('.cc-morepay'); if(morePay)morePay.addEventListener('click',function(){openCart(cartParts());});
  var stickyAtc=document.querySelector('.sticky-buy>button:last-child'); if(stickyAtc)stickyAtc.addEventListener('click',function(){openCart(cartParts());});
  function toBuy(){var b=document.getElementById('buy');if(b)b.scrollIntoView({behavior:'smooth'});}
  if(stickyInfo)stickyInfo.addEventListener('click',toBuy);
  var fin=document.querySelector('.final-cta button'); if(fin)fin.addEventListener('click',toBuy);
  [].slice.call(document.querySelectorAll('.variant-links button')).forEach(function(b,i){
    b.addEventListener('click',function(){ if(i===0){state.variant='kids';} if(i===1){state.variant='pet';} render(); toBuy(); });
  });

  var mainImg=document.querySelector('.main-image');
  [].slice.call(document.querySelectorAll('.thumb-row .thumb')).forEach(function(btn){
    btn.addEventListener('click',function(){
      var im=btn.querySelector('img'); if(!im)return;
      mainImg.src=im.src;
      document.querySelectorAll('.thumb-row .thumb').forEach(function(x){x.classList.remove('active');x.setAttribute('aria-pressed','false');});
      btn.classList.add('active');btn.setAttribute('aria-pressed','true');
    });
  });

  var card=document.querySelector('.comparison-card');
  [].slice.call(document.querySelectorAll('.comparison-labels button')).forEach(function(b,i){
    b.addEventListener('click',function(){
      card.classList.toggle('show-without',i===0);
      card.classList.toggle('show-with',i===1);
      document.querySelectorAll('.comparison-labels button').forEach(function(x,xi){x.classList.toggle('active',xi===i);x.setAttribute('aria-pressed',xi===i);});
    });
  });

  [].slice.call(document.querySelectorAll('.spec-tabs button')).forEach(function(b,i){
    b.addEventListener('click',function(){
      document.querySelectorAll('.spec-tabs button').forEach(function(x,xi){x.classList.toggle('selected',xi===i);});
      document.querySelectorAll('.spec-panel-data').forEach(function(p){p.hidden=(+p.dataset.tab)!==i;});
    });
  });

  // bundle builder (kept from the current PDP; cart routing mirrors the bracelet discount fix)
  var bitems=[].slice.call(document.querySelectorAll('#ccn2 .bitem'));
  var bcta=document.getElementById('bcta');
  function renderBundle(){
    if(!bcta)return;
    var sel=[].slice.call(document.querySelectorAll('#ccn2 .bitem.on'));var btxt=document.getElementById('btxt'),btot=document.getElementById('btot');var nAdd=sel.length,name=state.variant==='pet'?'Pendant':'Necklace',unit=VARIANTS[state.variant].price,qty=state.qty;var addons=sel.reduce(function(s,x){return s+ +x.dataset.price;},0);if(nAdd){var count=qty+nAdd,rate=count>=4?0.2:0.1,full=unit*qty+addons,save=full*rate;if(btxt)btxt.innerHTML=count+' items: <b>'+(rate*100)+'% off your whole bundle</b> (save $'+save.toFixed(2)+'), applied automatically at checkout'+(count>=4?'':' · add '+(4-count)+' more for 20%');if(btot)btot.innerHTML='<s>$'+full.toFixed(2)+'</s>$'+(full-save).toFixed(2);bcta.textContent='Add '+name+' + '+nAdd+' to cart';}else{if(btxt)btxt.textContent='Select add-ons above. Bundle savings apply automatically at checkout.';if(btot)btot.textContent='';bcta.textContent='Add '+name+' to cart';}
  }
  bitems.forEach(function(b){b.addEventListener('click',function(){b.classList.toggle('on');renderBundle();});});
  if(bcta)bcta.addEventListener('click',function(){
    var addons=[].slice.call(document.querySelectorAll('#ccn2 .bitem.on')).map(function(b){return b.dataset.variantId+':1';});
    var v=VARIANTS[state.variant], first;
    if(addons.length>0||state.qty>1) first=v.dup+':'+state.qty;
    else first=v.vid+':1';
    openCart([first].concat(addons));
  });

  // gallery nav: arrows, swipe, draggable thumb strip
  (function(){
    var main=document.querySelector('.main-image'); if(!main)return;
    var row=document.querySelector('.thumb-row');
    function thumbs(){return [].slice.call(document.querySelectorAll('.thumb-row .thumb'));}
    function cur(){var t=thumbs();for(var i=0;i<t.length;i++){if(t[i].classList.contains('active'))return i;}return 0;}
    function show(i){var t=thumbs();if(!t.length)return;i=(i+t.length)%t.length;
      t.forEach(function(x){x.classList.remove('active');x.setAttribute('aria-pressed','false');});
      var n=t[i]; n.classList.add('active'); n.setAttribute('aria-pressed','true');
      var im=n.querySelector('img'); if(im){main.src=im.src;}
      try{n.scrollIntoView({block:'nearest',inline:'nearest'});}catch(e){}}
    var prev=document.getElementById('gprev'),next=document.getElementById('gnext');
    if(prev)prev.addEventListener('click',function(e){e.preventDefault();show(cur()-1);});
    if(next)next.addEventListener('click',function(e){e.preventDefault();show(cur()+1);});
    var sx=0,sy=0,swiped=false;
    main.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;sy=e.touches[0].clientY;swiped=false;},{passive:true});
    main.addEventListener('touchend',function(e){
      var dx=e.changedTouches[0].clientX-sx, dy=e.changedTouches[0].clientY-sy;
      if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.5){swiped=true;show(cur()+(dx<0?1:-1));}
    },{passive:true});
    /* Ben 9/21: the main image was the biggest dead-click source on the page (Clarity,
       16 dead clicks / 124 sessions). Clicking it now advances the gallery, matching the
       next arrow. A swipe sets `swiped` so the trailing click does not advance twice. */
    main.style.cursor='pointer';
    main.addEventListener('click',function(e){
      if(swiped){swiped=false;return;}
      e.preventDefault();show(cur()+1);
    });
    if(row){
      var down=false,startX=0,startL=0,moved=false;
      row.addEventListener('pointerdown',function(e){down=true;moved=false;startX=e.clientX;startL=row.scrollLeft;});
      window.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-startX;if(Math.abs(dx)>6)moved=true;if(moved){row.scrollLeft=startL-dx;e.preventDefault();}});
      window.addEventListener('pointerup',function(){down=false;});
      row.addEventListener('click',function(e){if(moved){e.stopPropagation();e.preventDefault();moved=false;}},true);
      row.addEventListener('dragstart',function(e){e.preventDefault();});
    }
  })();
  render();
})();


/* 2026-10-01 reviews carousel (Lattice behaviour) + buy prompt scrolls to the purchase panel */
(function(){var rc=document.querySelector('#ccn3 .cc-revband .rev-cards');if(!rc)return;
var step=function(){var c=rc.querySelector('.rev-card');return c?c.getBoundingClientRect().width+18:300;};
var atEnd=function(){return rc.scrollLeft+rc.clientWidth>=rc.scrollWidth-10;};
document.querySelector('#ccn3 .cc-revband .rev-arrow.next').addEventListener('click',function(){atEnd()?rc.scrollTo({left:0}):rc.scrollBy({left:step()});});
document.querySelector('#ccn3 .cc-revband .rev-arrow.prev').addEventListener('click',function(){rc.scrollLeft<10?rc.scrollTo({left:rc.scrollWidth}):rc.scrollBy({left:-step()});});
var timer=null;var auto=function(){if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;timer=setInterval(function(){atEnd()?rc.scrollTo({left:0}):rc.scrollBy({left:step()});},4500);};
var stop=function(){if(timer){clearInterval(timer);timer=null;}};var car=document.querySelector('#ccn3 .cc-revband .rev-carousel');
car.addEventListener('mouseenter',stop);car.addEventListener('mouseleave',function(){if(!timer)auto();});car.addEventListener('touchstart',stop,{passive:true});auto();
var tb=document.querySelector('#ccn3 .cc-tobuy');if(tb)tb.addEventListener('click',function(e){e.preventDefault();var p=document.querySelector('#ccn3 .purchase-panel');if(p)p.scrollIntoView({behavior:'smooth',block:'start'});});})();

/* 2026-10-01 review rail: Add to cart = main ADD TO CART with the current selection; price follows the selection */
(function(){var a=document.querySelector('#ccn3 .cc-bpatc');if(!a)return;
a.addEventListener('click',function(e){e.preventDefault();var m=document.querySelector('#ccn3 .primary-btn');if(m)m.click();});
var src=document.querySelector('#ccn3 .price-row strong'),dst=document.querySelector('#ccn3 .cc-bpprice');if(!src||!dst)return;var first=src.textContent;
new MutationObserver(function(){var t=src.textContent;dst.textContent=(t===first)?'from $98':t;}).observe(src,{childList:true,characterData:true,subtree:true});})();
